import React, { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import DiscoverySuiteAddOns from 'components/common/subscribed-user-billing/add-ons/DiscoverySuiteContainer'
import DiscoModal from 'components/ui/disco-modal'

type DiscoverySuiteModalState = {
  returnTo?: string
  returnToState?: unknown
}

const DiscoverySuiteModal = (): React.ReactNode => {
  const location = useLocation()
  const navigate = useNavigate()
  const state = location.state as DiscoverySuiteModalState | null

  const query = new URLSearchParams(location.search)
  const trackId = Number(query.get('trackId') || '')

  const onClose = useCallback(() => {
    if (state?.returnToState != null) {
      navigate(state.returnTo ?? '/', {
        state: state.returnToState,
      })
      return
    }

    navigate(state?.returnTo ?? '/')
  }, [navigate, state])

  return (
    <DiscoModal onRequestClose={onClose}>
      <DiscoverySuiteAddOns isModalExplorerRoute trackId={trackId} />
    </DiscoModal>
  )
}

export default DiscoverySuiteModal
